import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ActivityMetadata from '~/client/components/activity-metadata/activity-metadata';
import Breadcrumbs from '~/client/components/breadcrumbs/breadcrumbs';
import Carousel from '~/client/components/carousel/carousel';
import ContentContainer from '~/client/components/content-container/content-container';
import EmbedMedia from '~/client/components/embed-media/embed-media';
import Layout from '~/client/components/layout/layout';
import LinkBox from '~/client/components/link-box/link-box';
import RichText from '~/client/components/rich-text/rich-text';
import SidebarLayout from '~/client/components/sidebar-layout/sidebar-layout';
import type { ExercisePage as Props } from './exercise-page.types';

const ExercisePage: React.FunctionComponent<Props> = ({
  activityMetadata,
  breadcrumbs,
  description,
  header,
  layout,
  related,
}) => (
  <Layout {...layout}>
    <Breadcrumbs {...breadcrumbs} />
    <SidebarLayout>
      <SidebarLayout.Top>
        {header.media ? (
          <EmbedMedia
            theme={EmbedMedia.themes.paddedButtons}
            {...header.media}
          />
        ) : null}
      </SidebarLayout.Top>

      <SidebarLayout.Sidebar>
        <ActivityMetadata {...activityMetadata} />
      </SidebarLayout.Sidebar>

      <SidebarLayout.Content>
        <Text
          elementName="h1"
          size={Text.sizes.headline1}
          theme={Text.themes.headline}
          italic
          className="exercise-page__heading"
        >
          {header.title}
        </Text>
        <div className="exercise-page__description">
          {description.map(({ title, text }, i) => (
            <div key={title || i}>
              {title ? (
                <Text
                  className="exercise-page__description-title"
                  elementName="h2"
                  size={Text.sizes.headline2}
                  theme={Text.themes.emphasis}
                >
                  {title}
                </Text>
              ) : null}
              <RichText className="exercise-page__text" {...text} />
            </div>
          ))}
        </div>
      </SidebarLayout.Content>
    </SidebarLayout>

    {related ? (
      <ContentContainer>
        <div className="exercise-page__related">
          <Carousel {...related} entryRenderer={LinkBox} />
        </div>
      </ContentContainer>
    ) : null}
  </Layout>
);

export default ExercisePage;
